
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("9nY0o", function(module, exports) {
// Intent-time preload seam for chat-side modules. Fire-and-forget; experiment-gated; once per page load.

var $c6GJD = parcelRequire("c6GJD");

// Intent-time preload for the LazyCardWithUrlContent chunk; chunk name mirrors `view/CardWithUrl/loader.tsx`.

const $03440d6b72110eb9$export$e8ff3768de40dcb2 = ()=>(parcelRequire("hYiyU"));



var $bkHj8 = parcelRequire("bkHj8");


var $1CBzK = parcelRequire("1CBzK");


var $aNNfK = parcelRequire("aNNfK");

const $97dae280575301ff$var$PRELOADER_SMART_CARD = 'smart-card';
const $97dae280575301ff$var$PRELOADER_AUTO_SUGGEST = 'auto-suggest';
const $97dae280575301ff$var$PRELOADER_SMART_CREATION = 'smart-creation';
const $97dae280575301ff$var$PRELOADER_FEEDBACK_FLAG = 'feedback-flag';
const $97dae280575301ff$var$ALL_PRELOADERS = [
    $97dae280575301ff$var$PRELOADER_SMART_CARD,
    $97dae280575301ff$var$PRELOADER_AUTO_SUGGEST,
    $97dae280575301ff$var$PRELOADER_SMART_CREATION,
    $97dae280575301ff$var$PRELOADER_FEEDBACK_FLAG
];
let $97dae280575301ff$var$hasPreloadedChatOnIntent = false;
function $97dae280575301ff$var$isPreloaderName(preloader) {
    return $97dae280575301ff$var$ALL_PRELOADERS.includes(preloader);
}
function $97dae280575301ff$var$getEnabledPreloaders(cohort) {
    return new Set(cohort.split(',').map((preloader)=>preloader.trim()).filter(Boolean).filter($97dae280575301ff$var$isPreloaderName));
}
function $97dae280575301ff$var$preloadSmartCard() {
    (0, $03440d6b72110eb9$export$e8ff3768de40dcb2)().catch(()=>{});
}
function $97dae280575301ff$var$preloadAutoSuggest() {
    (0, $bkHj8.importAutoSuggest)().catch(()=>{});
}
function $97dae280575301ff$var$preloadSmartCreationWrapper() {
    (0, $aNNfK.importSmartCreationWrapper)().catch(()=>{});
}
function $97dae280575301ff$var$preloadFeedbackFlag() {
    (0, $1CBzK.importFeedbackFlag)().catch(()=>{});
}
function $97dae280575301ff$export$778f6ecee92cc30c() {
    if (typeof window === 'undefined') return;
    if ($97dae280575301ff$var$hasPreloadedChatOnIntent) return;
    $97dae280575301ff$var$hasPreloadedChatOnIntent = true;
    const enabledPreloaders = $97dae280575301ff$var$getEnabledPreloaders((0, $c6GJD.default).getExperimentValue('chat_preload_components_exp', 'cohort', '', {
        fireExperimentExposure: true
    }));
    if (enabledPreloaders.size === 0) return;
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_SMART_CARD)) $97dae280575301ff$var$preloadSmartCard();
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_AUTO_SUGGEST)) $97dae280575301ff$var$preloadAutoSuggest();
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_SMART_CREATION)) $97dae280575301ff$var$preloadSmartCreationWrapper();
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_FEEDBACK_FLAG)) $97dae280575301ff$var$preloadFeedbackFlag();
}
module.exports["preloadChatOnIntent"] = $97dae280575301ff$export$778f6ecee92cc30c;

});

parcelRegister("hYiyU", function(module, exports) {

let $d15670492ea5a554$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d15670492ea5a554$var$load("3VIZM"),
    $d15670492ea5a554$var$load("gyh6H"),
    $d15670492ea5a554$var$load("1F7LX"),
    $d15670492ea5a554$var$load("jZLnv"),
    $d15670492ea5a554$var$load("6edij"),
    $d15670492ea5a554$var$load("gknbb"),
    $d15670492ea5a554$var$load("6iz6l"),
    $d15670492ea5a554$var$load("4SCW2"),
    $d15670492ea5a554$var$load("36QeB"),
    $d15670492ea5a554$var$load("9q75n"),
    $d15670492ea5a554$var$load("iYHbd"),
    $d15670492ea5a554$var$load("cHb2G"),
    $d15670492ea5a554$var$load("8hQ27"),
    $d15670492ea5a554$var$load("keNIN"),
    $d15670492ea5a554$var$load("hnGEQ"),
    $d15670492ea5a554$var$load("3GuOt"),
    $d15670492ea5a554$var$load("jbM5v"),
    $d15670492ea5a554$var$load("dek7I"),
    $d15670492ea5a554$var$load("dYtBN"),
    $d15670492ea5a554$var$load("kNV5Y"),
    $d15670492ea5a554$var$load("6SWFK"),
    $d15670492ea5a554$var$load("9aQIt"),
    $d15670492ea5a554$var$load("5zapo"),
    $d15670492ea5a554$var$load("3MYQs"),
    $d15670492ea5a554$var$load("XZauT"),
    $d15670492ea5a554$var$load("4S1SF"),
    $d15670492ea5a554$var$load("jiFtb"),
    $d15670492ea5a554$var$load("lm9Lt"),
    $d15670492ea5a554$var$load("9atVd"),
    $d15670492ea5a554$var$load("9wPDc"),
    $d15670492ea5a554$var$load("1MWOL"),
    $d15670492ea5a554$var$load("6fQco"),
    $d15670492ea5a554$var$load("aOY32"),
    $d15670492ea5a554$var$load("7jSfd"),
    $d15670492ea5a554$var$load("4HZlX"),
    $d15670492ea5a554$var$load("kDqHr"),
    $d15670492ea5a554$var$load("6wr18"),
    $d15670492ea5a554$var$load("gT8XU"),
    $d15670492ea5a554$var$load("lE8tR"),
    $d15670492ea5a554$var$load("alA4m"),
    $d15670492ea5a554$var$load("ffEVr"),
    $d15670492ea5a554$var$load("7EorR"),
    $d15670492ea5a554$var$load("oTA4y"),
    $d15670492ea5a554$var$load("fPbCp"),
    $d15670492ea5a554$var$load("kuFG2"),
    $d15670492ea5a554$var$load("Wowvf"),
    $d15670492ea5a554$var$load("hhss7"),
    $d15670492ea5a554$var$load("i4cia")
]).then(()=>parcelRequire('bAzak'));

});

parcelRegister("bkHj8", function(module, exports) {
// Canonical dynamic-import factory for `@atlassian/conversation-assistant-auto-suggest`. Shared by the live
// `lazy()` boundary and intent-time preload to keep chunk identity single-sourced.

function $a271a3136aaf0862$export$5531859f311f2932() {
    return (parcelRequire("fNUHF"));
}
module.exports["importAutoSuggest"] = $a271a3136aaf0862$export$5531859f311f2932;

});

parcelRegister("fNUHF", function(module, exports) {

let $b8176ab7ca17432b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b8176ab7ca17432b$var$load("6wr18"),
    $b8176ab7ca17432b$var$load("cHb2G"),
    $b8176ab7ca17432b$var$load("lE8tR"),
    $b8176ab7ca17432b$var$load("alA4m"),
    $b8176ab7ca17432b$var$load("ffEVr"),
    $b8176ab7ca17432b$var$load("cX4Bp"),
    $b8176ab7ca17432b$var$load("dawn8"),
    $b8176ab7ca17432b$var$load("aQh37"),
    $b8176ab7ca17432b$var$load("bJVDE"),
    $b8176ab7ca17432b$var$load("oTA4y"),
    $b8176ab7ca17432b$var$load("fPbCp"),
    $b8176ab7ca17432b$var$load("kuFG2"),
    $b8176ab7ca17432b$var$load("1F7LX"),
    $b8176ab7ca17432b$var$load("3QXpo"),
    $b8176ab7ca17432b$var$load("hhss7"),
    $b8176ab7ca17432b$var$load("h3ABO"),
    $b8176ab7ca17432b$var$load("kC80R"),
    $b8176ab7ca17432b$var$load("397zr")
]).then(()=>parcelRequire('8AQV8'));

});

parcelRegister("1CBzK", function(module, exports) {
// Single-source dynamic import factory for the feedback-flag chunk.
// Mirrors the chunk-name used by every live `lazy()` boundary so preload and
// the live boundary share the same chunk identity.

const $af524f9041864d2f$export$1eafe3a5df99a0a0 = ()=>(parcelRequire("hEkII"));
module.exports["importFeedbackFlag"] = $af524f9041864d2f$export$1eafe3a5df99a0a0;

});

parcelRegister("hEkII", function(module, exports) {

let $cd963eae86499499$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cd963eae86499499$var$load("2xz6W").then(()=>parcelRequire('gHwil'));

});

parcelRegister("aNNfK", function(module, exports) {
// Single-source dynamic import factory for the smart-creation-wrapper chunk.
// Mirrors the chunk-name used by every live `lazy()` boundary so preload and
// the live boundary share the same chunk identity.

const $85c671e208740b9c$export$f67978e62543a686 = ()=>(parcelRequire("eXtig"));
module.exports["importSmartCreationWrapper"] = $85c671e208740b9c$export$f67978e62543a686;

});

parcelRegister("eXtig", function(module, exports) {

let $ae3d4c7289b77051$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ae3d4c7289b77051$var$load("ez4I6"),
    $ae3d4c7289b77051$var$load("aQMre"),
    $ae3d4c7289b77051$var$load("b9CA3"),
    $ae3d4c7289b77051$var$load("2YffH"),
    $ae3d4c7289b77051$var$load("lUDr0"),
    $ae3d4c7289b77051$var$load("8dwgS"),
    $ae3d4c7289b77051$var$load("9XOeB"),
    $ae3d4c7289b77051$var$load("xu7ej"),
    $ae3d4c7289b77051$var$load("iQ4FP"),
    $ae3d4c7289b77051$var$load("71gca"),
    $ae3d4c7289b77051$var$load("fbwYT"),
    $ae3d4c7289b77051$var$load("gdwbX"),
    $ae3d4c7289b77051$var$load("82Jpo"),
    $ae3d4c7289b77051$var$load("eXKRO"),
    $ae3d4c7289b77051$var$load("im1VN"),
    $ae3d4c7289b77051$var$load("4HHsa"),
    $ae3d4c7289b77051$var$load("czOM6"),
    $ae3d4c7289b77051$var$load("5yluq"),
    $ae3d4c7289b77051$var$load("2tcSk"),
    $ae3d4c7289b77051$var$load("8pLtn"),
    $ae3d4c7289b77051$var$load("8auEH"),
    $ae3d4c7289b77051$var$load("jAeEl"),
    $ae3d4c7289b77051$var$load("lKs3T"),
    $ae3d4c7289b77051$var$load("9anPW"),
    $ae3d4c7289b77051$var$load("3EXzu"),
    $ae3d4c7289b77051$var$load("b2FtX"),
    $ae3d4c7289b77051$var$load("gnDXu"),
    $ae3d4c7289b77051$var$load("dl2qY"),
    $ae3d4c7289b77051$var$load("kL5FA"),
    $ae3d4c7289b77051$var$load("6iz6l"),
    $ae3d4c7289b77051$var$load("4SCW2"),
    $ae3d4c7289b77051$var$load("9q75n"),
    $ae3d4c7289b77051$var$load("iYHbd"),
    $ae3d4c7289b77051$var$load("8hQ27"),
    $ae3d4c7289b77051$var$load("keNIN"),
    $ae3d4c7289b77051$var$load("3VIZM"),
    $ae3d4c7289b77051$var$load("gyh6H"),
    $ae3d4c7289b77051$var$load("gBV5J"),
    $ae3d4c7289b77051$var$load("djjX5"),
    $ae3d4c7289b77051$var$load("c0JsV"),
    $ae3d4c7289b77051$var$load("h3ABO"),
    $ae3d4c7289b77051$var$load("iUEjf"),
    $ae3d4c7289b77051$var$load("YAi2k"),
    $ae3d4c7289b77051$var$load("adNrA"),
    $ae3d4c7289b77051$var$load("oTA4y"),
    $ae3d4c7289b77051$var$load("fPbCp"),
    $ae3d4c7289b77051$var$load("6wr18"),
    $ae3d4c7289b77051$var$load("kzjZo"),
    $ae3d4c7289b77051$var$load("Wowvf"),
    $ae3d4c7289b77051$var$load("cX4Bp"),
    $ae3d4c7289b77051$var$load("dawn8"),
    $ae3d4c7289b77051$var$load("ffEVr"),
    $ae3d4c7289b77051$var$load("hhss7"),
    $ae3d4c7289b77051$var$load("aQh37"),
    $ae3d4c7289b77051$var$load("bJVDE"),
    $ae3d4c7289b77051$var$load("1F7LX"),
    $ae3d4c7289b77051$var$load("3QXpo"),
    $ae3d4c7289b77051$var$load("jnVKv"),
    $ae3d4c7289b77051$var$load("7EorR"),
    $ae3d4c7289b77051$var$load("bgHzk"),
    $ae3d4c7289b77051$var$load("cU3hB")
]).then(()=>parcelRequire('k9rA8'));

});


//# sourceMappingURL=preload-chat-on-intent.ff696086.js.map
